import React from 'react';
import { MdArrowForward } from 'react-icons/md';

const SeeAllLink = () => (
  <span className="flex items-center gap-2 lg:gap-4">
    Lihat semua
    <MdArrowForward color="#CE181E" size={18} />
  </span>
);

export default SeeAllLink;
